import { createHook } from 'react-sweet-state';
import { store } from '../../main';
var selectTriggerFieldInitializationKey = function selectTriggerFieldInitializationKey(state) {
  return state.triggerFieldInitializationKey;
};
export var useTriggerFieldInitialization = createHook(store, {
  selector: selectTriggerFieldInitializationKey
});